export const isWebView = () => navigator.userAgent.toLowerCase().includes("wv");

export const isIFrame = () => window.self !== window.top;

export const browserEnvironment = () => {
  if (isIFrame()) {
    return "iframe";
  }
  if (isWebView()) {
    return "webview";
  }
  return "browser";
};

export const isJellybeanOrKitkat = () =>
  navigator.userAgent.toLowerCase().includes("android 4.1.1") ||
  navigator.userAgent.toLowerCase().includes("android 4.4");

export const isOffline = () => !window.navigator.onLine;
